// extracted by mini-css-extract-plugin
module.exports = {"block":"_1Lx9tSHsKSR831DW","award":"_1sL398duOS12BA3-","awardContainer":"lWk_UpmoWFYSUPsx"};